import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  app_net_states: [],
  app_net_state: {},
  app_net_list_view: {},
  app_net_revisions: [],
  app_net_revisions_view: {},
  user_error: {},
  application_network_state: {},
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}



// WEBPACK FOOTER //
// ./src/modules/applicationNetworkStates/store/index.js